import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'ml-row-checkbox, [row-checkbox]',
  templateUrl: './row-checkbox.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule],
})
export class RowCheckboxComponent {
  readonly description = input.required<string>();
  readonly id = input.required<string>();
  readonly editing = input(false);
  readonly label = input.required<string>();
}
